import { Component, Input, OnInit } from "@angular/core";
import { DashboardVisitorService } from "../dashboard-visitor.service";

@Component({
	selector: "caass-todays-visitor-stats",
	templateUrl: "./todays-visitor-stats.component.html",
	styleUrls: ["./todays-visitor-stats.component.css"],
})
export class TodaysVisitorStatsComponent implements OnInit {
	constructor(private dashboardService: DashboardVisitorService) {}

	ngOnInit(): void {
		this.loadData();
	}

	ngOnChanges() {
		this.loadData();
	}

	///////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////

	@Input() FacilityID: any;

	// VisitorCount: string = "N/A";
	InCount: string = "N/A";
	OutCount: string = "N/A";
	SysOutCount: string = "N/A";
	DenyCount: string = "N/A";
	// CheckPointCount: string = "N/A";
	InBuildingCount: string = "N/A";

	///////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////////
	loadData() {
		this.ResetData();

		if (this.FacilityID == undefined || this.FacilityID <= 0) {
			return;
		}

		var result = this.dashboardService.TodaysVisitorStatsSelect(this.FacilityID);
		result.subscribe(
			(response) => {
				var data: any = response;

				try {
					// this.VisitorCount = String(data.VisitorCount);
					this.InCount = String(data.InCount);
					this.OutCount = String(data.OutCount);
					this.SysOutCount = String(data.SysOutCount);
					this.DenyCount = String(data.DenyCount);
					// this.CheckPointCount = String(data.CheckPointCount);
					this.InBuildingCount = String(data.InBuildingCount);
				} catch (e) {
					e.toString();
				}
			},
			(error) => {}
		);
	}
	///////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////////

	ResetData() {
		// this.VisitorCount = "N/A";
		this.InCount = "N/A";
		this.OutCount = "N/A";
		this.SysOutCount = "N/A";
		this.DenyCount = "N/A";
		// this.CheckPointCount = "N/A";
		this.InBuildingCount = "N/A";
	}

	///////////////////////////////////////////////////////////
}
